/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { Formik } from 'formik'
import { Editor } from '@tinymce/tinymce-react'
import moment from 'moment'
import LoadingButton from '../../LoadingButton'

interface Props {
  open: boolean
  handleClose: () => void
  note: string
  addNotes: (values: { notes: string }) => Promise<void>
  handleEditorChange: (
    event: {
      target: {
        getContent: () => string
      }
    },
    setFieldValue: (field: string, value: string) => void,
    field: string,
  ) => void
  editorRef: React.MutableRefObject<any>
  editorEnable: boolean
  isLoading: boolean
}

const NoteModal: FC<Props> = props => {
  const {
    open,
    note,
    addNotes,
    handleClose,
    editorRef,
    handleEditorChange,
    editorEnable,
    isLoading,
  } = props
  return (
    <Modal
      show={open}
      onHide={(): void => handleClose()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="maneuver_modal note_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">ADD NOTES</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik onSubmit={addNotes} initialValues={{ notes: note }}>
          {({ handleSubmit, setFieldValue, values, dirty }): ReactElement => (
            <Form noValidate onSubmit={handleSubmit} className="form">
              <Form.Group controlId="notes">
                <Editor
                  textareaName="notes"
                  apiKey="dc71buijbp92lbdveqijzgigj9gxfosqm6li1pr7o1s20vds"
                  value={values.notes}
                  onInit={(evt, editor): void => {
                    editorRef.current = editor
                  }}
                  id="notes"
                  init={{
                    auto_focus: true,
                    browser_spellcheck: true,
                    branding: false,
                    br_in_pre: true,
                    menu: {
                      custom: {
                        title: 'Custom Menu',
                        items: 'undo redo myCustomMenuItem',
                      },
                    },
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link',
                      'searchreplace visualblocks',
                      'paste',
                      'contextmenu',
                    ],
                    contextmenu: 'paste link ',
                    setup: (editor): void => {
                      editor.ui.registry.addButton('menuDateButton', {
                        icon: 'insert-time',
                        onAction() {
                          editor.insertContent(
                            `<strong>${moment(new Date()).format('ddd - MM-DD-YYYY -')}</strong>`,
                          )
                        },
                      })
                    },
                    toolbar:
                      'menuDateButton | bullist | numlist | bold italic underline outdent indent',
                  }}
                  onEditorChange={(value): void => {
                    setFieldValue('notes', value)
                  }}
                  onChange={(value): void => {
                    handleEditorChange(value, setFieldValue, 'notes')
                  }}
                  disabled={!editorEnable}
                />
              </Form.Group>
              <Form.Group>
                <LoadingButton
                  disabled={!dirty}
                  isLoading={isLoading}
                  variant="outline-primary"
                  type="submit"
                >
                  Save
                </LoadingButton>
              </Form.Group>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default NoteModal
